import { Grid, Tenant } from '@zappyrent/hundop';
import { useTranslation } from 'react-i18next';

import {
  StyledProfileButton,
  StyledToolbar,
  StyledWrapper,
} from './Header.styles';
import { IHeaderProps } from './Header.types';
import LanguageSwitch from '../../UI/LanguageSwitch';
import Logo from '../../UI/Logo';

const Header = ({ onProfileBtnClick }: IHeaderProps): JSX.Element => {
  const { t } = useTranslation(['common']);

  return (
    <StyledWrapper>
      <Grid
        direction="row"
        justifyContent="space-between"
        alignItems="center"
        container
      >
        <Logo />
        <StyledToolbar>
          <StyledProfileButton
            title={t('myProfile')}
            onClick={onProfileBtnClick}
          >
            <Tenant />
            <span>{t('myProfile')}</span>
          </StyledProfileButton>
          <LanguageSwitch />
        </StyledToolbar>
      </Grid>
    </StyledWrapper>
  );
};

export default Header;
